<template>
  <div class="debug-console" data-simplebar="" v-if="debugValues && debugValues.length > 0">
    <ul>
      <template v-for="group in debugValues.slice().reverse()">
        <li :class="group.noAnimation ? '' : 'animation'" :key="group.Id">
          <div><span>{{group.Value}}</span></div>
          <ul>
            <li v-for="(item, index) in group.Items" :key="index">
              <span v-if="item.Label">
                {{ item.Label }}:
              </span>
              <span>
                {{ item.Value }}
              </span>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      //addClass: false,
      //doAnimate: false,
      //timeOut: null,
    }
  },
  computed: {
    ...mapState({
      debugValues: state => state.debugConsole.debugValues
    }),
  },
  watch:{
    debugValues(values) {
      if(!values || values.length > 1)
        return;

      values[0].noAnimation = true;
      //this.doAnimate = true;
      // if(this.addClass) {
      //   this.addClass = false;
      //   setTimeout(() => {
      //     this.adding();
      //   }, 50);
      // }
      // else
      //this.adding();
    }
  }//,
  // methods: {
  //   adding: function() {
  //     this.addClass = true
  //     clearTimeout(this.timeOut);

  //     this.timeOut = setTimeout(() => {
  //       this.addClass = false
  //     }, 5000);
  //   }
  // }
}
</script>
